// extracted by mini-css-extract-plugin
export default {"form":"styles_form__2byyS","input":"styles_input__W04W-","photoContainer":"styles_photoContainer__yD7+7","image":"styles_image__qAfln"};